module.exports = __webpack_public_path__ + "../front/img/468med5hylder.2381864a.svg";